'use client';

import { ENGLISH_IQ_EVENTS } from '@repo/analytics';
import {
  ENGLISH_IQ_MAX_SECONDS,
  ENGLISH_IQ_STORED_SESSION_VERSION,
  type SupportedLocaleType,
} from '@repo/config';
import { getOrCreateVisitorId, trackEvent } from '@repo/web-chrome/lib/analytics';
import type { Dispatch, SetStateAction } from 'react';
import { startEnglishIqWebSession } from '../actions';
import type { IEnglishIqStoredSession } from '../state';

interface IUseEnglishIqStartParams {
  locale: SupportedLocaleType;
  setError: Dispatch<SetStateAction<string | null>>;
  setIsBusy: Dispatch<SetStateAction<boolean>>;
  storeSession: (session: IEnglishIqStoredSession) => void;
}

export function useEnglishIqStart(params: IUseEnglishIqStartParams) {
  return async (turnstileToken?: string): Promise<void> => {
    params.setIsBusy(true);
    params.setError(null);
    try {
      const data = await startEnglishIqWebSession(
        params.locale,
        getOrCreateVisitorId(),
        turnstileToken,
      );
      const startedAt = Date.now();
      params.storeSession({
        expiresAt: startedAt + ENGLISH_IQ_MAX_SECONDS * 1000,
        index: 1,
        item: data.item,
        locale: params.locale,
        milestone: null,
        startedAt,
        token: data.token,
        version: ENGLISH_IQ_STORED_SESSION_VERSION,
      });
      trackEvent(ENGLISH_IQ_EVENTS.testStart, { surface: 'web' });
    } catch {
      params.setError('start');
    } finally {
      params.setIsBusy(false);
    }
  };
}
